import { render, staticRenderFns } from "./DigitalRecordDownloads.vue?vue&type=template&id=4daff725"
import script from "./DigitalRecordDownloads.vue?vue&type=script&lang=js"
export * from "./DigitalRecordDownloads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports